import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { Avatar, IconButton } from "@mui/material";
import { Close } from "@mui/icons-material";
import "./index.scss";

const CustomModal = ({
  title,
  children,
  onClose,
  contentClassName,
  classesToPreventClosing = [],
  disabledOutsideClick,
  closeOnOutsideClick,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  let modalRef = useRef();

  // Show modal with animation
  useEffect(() => {
    setIsVisible(true);
  }, []);

  // Disable scroll on body when modal is open
  useEffect(() => {
    let body = document.getElementsByTagName("body")[0];
    body.style.overflow = "hidden";
    return () => {
      body.style.overflow = "scroll";
    };
  }, []);

  // Close modal on outside click
  useEffect(() => {
    const handler = (event) => {
      if (!modalRef.current.contains(event.target)) {
        let preventFromClosing = false;

        classesToPreventClosing.forEach((item) => {
          const classString =
            typeof event?.target?.className === "object"
              ? event?.target?.className?.baseVal
              : event?.target?.className || "";

          if (classString.includes(item)) {
            preventFromClosing = true;
          }
        });
        if (preventFromClosing) return;
        if (!disabledOutsideClick) closeModal();
      }
    };
    document.addEventListener("mousedown", handler);
    return () => {
      document.removeEventListener("mousedown", handler);
    };
  }, [classesToPreventClosing, disabledOutsideClick]);

  const closeModal = () => {
    setIsVisible(false);
    setTimeout(() => {
      if (typeof onClose === "function") onClose();
    }, 500); // Match this duration to the CSS transition duration
  };

  return (
    <div className={`custom-modal-backdrop ${isVisible ? "show" : ""}`}>
      <div className={`custom-modal-container ${isVisible ? "show" : ""}`}>
        <div className={`${contentClassName} modal-content`} ref={modalRef}>
          {onClose && (
            <div className="close">
              <IconButton onClick={closeModal} size="small">
                <Avatar
                  sx={{
                    width: "25px",
                    height: "25px",
                    backgroundColor: "#E5E5E5",
                  }}
                >
                  <Close fontSize="5" sx={{ color: "#4F4F4F" }} />
                </Avatar>
              </IconButton>
            </div>
          )}
          <div className="main-modal-content">
            {title && (
              <div className="modal-header">
                <span className="modal-title">{title}</span>
              </div>
            )}
            <div className="modal-body">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

CustomModal.propTypes = {
  title: PropTypes.string,
  onClose: PropTypes.func,
  contentClassName: PropTypes.string,
  classesToPreventClosing: PropTypes.array,
  disabledOutsideClick: PropTypes.bool,
  closeOnOutsideClick: PropTypes.bool,
};

export default CustomModal;
